import React from 'react';
import { View, Text } from 'react-native';
import { useAuth } from 'app/auth/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { getDoctorTitle } from '@shared/utils/doctor';
import { IPathwayActivity } from 'app/_modules/pathways/entities';
import { StepCard } from './ActivityCard/StepCard';
import { AdherenceCard } from './AdherenceCard';
import { TutorialChip } from './TutorialChip';

interface HiHeaderComponentProps {
    stepsActivity?: IPathwayActivity;
}

const HiHeaderComponent = ({ stepsActivity }: HiHeaderComponentProps) => {
    const { user, meData } = useAuth();
    const { t } = useTranslation();
    const insets = useSafeAreaInsets();
    const doctor = meData?.current_pathway?.doctor;
    const docTitle = getDoctorTitle(doctor?.title, t);

    return (
        <View
            className='px-8 pb-6 bg-white border-b border-gray-200'
            style={{ paddingTop: insets.top + 24 }}>
            <View className='flex-row flex-wrap items-baseline gap-4'>
                <Text className='font-heading font-bold text-black text-5xl' >
                    {t('screens.home.header.hello')} {user?.given_name}!
                </Text>
                <Text className='font-body font-semibold text-gray-500 text-base' >
                    {`${t('screens.home.header.doctor')}: ${docTitle} ${doctor?.last_name
                        }`}
                </Text>
            </View>

            <View className='flex-row gap-4 mt-4'>
                <AdherenceCard />
                <TutorialChip />
            </View>

            {stepsActivity && (
                <View className='mt-4'>
                    <StepCard activity={stepsActivity} />
                </View>
            )}
        </View>
    );
};

export default HiHeaderComponent;
